import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { createMcpConnector } from '@/services/mcp-gateway';
import type { CreateMcpConnectorInput } from '@/services/mcp-gateway';

export function useCreateMcpConnector() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (input: CreateMcpConnectorInput) => createMcpConnector(input, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-connectors', orgId] });
    },
  });
}
